module.exports = __webpack_public_path__ + "src/assets/img/s-settings_w.7e54929e.svg";